import { render, staticRenderFns } from "./SupplierLink.vue?vue&type=template&id=d16abce4&scoped=true&"
import script from "./SupplierLink.vue?vue&type=script&lang=js&"
export * from "./SupplierLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16abce4",
  null
  
)

export default component.exports